module.exports = __webpack_public_path__ + "img/tysabri_logo_white.e9ca5acb.png";